export const anchorOriginParams = {
  vertical: "top",
  horizontal: "right",
};

export const hideDuration = 1500;
